export default {
  currentUser: {
    id: '',
    country: '',
    username: '',
    email: '',
    roles: []
  },
  currentStore: null
}
